import { getProfileDataThunk, resetUserEmailOrPhoneThunk } from '../../../../../store/workspace/thunks';
import { EditSquareIcon, CheckSolidIcon } from '../../../../../assets/icons';
import { selectProfile } from '../../../../../store/workspace/selectors';
import { setEditEmailModal } from '../../../../../store/workspace/slice';
import { useDispatch, useSelector } from '../../../../../store/store';
import { isBusinessEmail, validateEmail } from '../../../../../utils/generalHelpers';
import Button from '../../../../../components/Button';
import Modal from '../../../../../components/Modal';
import Input from '../../../../../components/Input';
import OTP from '../../../../../components/OTP';
import { useEffect, useState } from 'react';
import styles from './style.module.scss';
import { setPersonalEmailWarningModal } from '../../../../../store/signUp/slice';

type Step = 'Email' | 'Confirm' | 'Done';

export default function EditEmail() {
    const dispatch = useDispatch();
    const [otp, setOtp] = useState('');
    const profile = useSelector(selectProfile);
    const [email, setEmail] = useState('');
    const [step, setStep] = useState<Step>('Email');
    const [isLoading, setIsLoading] = useState(false);
    const [responseError, setResponseError] = useState('');
    const [emailErrorMessage, setEmailErrorMessage] = useState('');
    const [passwordErrorMessage, setPasswordErrorMessage] = useState('');
    const [password, setPassword] = useState<string>('');

    const submit = () => {
        if (!profile) return;

        switch (step) {
            case 'Email': {
                if (!isBusinessEmail(email)) {
                    dispatch(setPersonalEmailWarningModal(true));
                    return;
                }

                if (!validateEmail(email) || !password) {
                    !validateEmail(email) ? setEmailErrorMessage('Invalid email') : setEmailErrorMessage('');
                    !password ? setPasswordErrorMessage('Password is required') : setPasswordErrorMessage('');
                    return;
                }

                setIsLoading(true);
                dispatch(resetUserEmailOrPhoneThunk({
                    email: profile.email,
                    newEmail: email,
                    key: password,
                }))
                    .unwrap()
                    .then((res) => {
                        setStep('Confirm');
                    })
                    .catch((err) => {
                        console.log(err);
                        setResponseError(err?.message || 'Something went wrong,Try again...');
                    })
                    .finally(() => {
                        setIsLoading(false);
                    })
                break;
            }
            case 'Confirm':
                setIsLoading(true);
                dispatch(resetUserEmailOrPhoneThunk({
                    email: profile.email,
                    newEmail: email,
                    key: password,
                    verificationCode: otp,
                }))
                    .unwrap()
                    .then((res) => {
                        setStep('Done');
                        dispatch(getProfileDataThunk());
                    })
                    .catch((err) => {
                        console.log(err);
                        setResponseError(err?.message || 'Something went wrong,Try again...');
                    })
                    .finally(() => {
                        setIsLoading(false);
                    })
                break;
            case 'Done':
                dispatch(setEditEmailModal(false))
                break;
        }
    };

    useEffect(() => {
        if (otp.length !== 6) return;
        submit();
    }, [otp]);

    return (
        <Modal
            size='sm'
            title='Edit email'
            icon={<EditSquareIcon />}
            childClassName={styles.wrapper}
            closeFunc={() => dispatch(setEditEmailModal(false))}
        >
            {step === 'Email' && (
                <>
                    <Input
                        type='email'
                        value={email}
                        label='New email'
                        onChange={setEmail}
                        error={emailErrorMessage}
                    />
                    <Input
                        type='password'
                        value={password}
                        label='Current password'
                        onChange={setPassword}
                        error={passwordErrorMessage}
                    />
                </>
            )}

            {step === 'Confirm' && <div className={styles.confirm}>
                <span className={styles.description}>
                    Enter the sent code to:
                </span>
                <div className={styles.detail}>
                    <div className={styles.detail_phone}>
                        <span>{email}</span>
                    </div>
                    <span
                        onClick={() => setStep('Email')}
                        className={styles.detail_change_phone}
                    >
                        Change email
                    </span>
                </div>
                <OTP
                    value={otp}
                    onChange={setOtp}
                    numInputs={6}
                    onChangeRegex={/^([0-9]{0,})$/}
                />
            </div>}

            {step === 'Done' && <div className={styles.done}>
                <CheckSolidIcon />
                <span>
                    Email updated successfully
                </span>
            </div>}

            {responseError && <span className={styles.error}>{responseError}</span>}

            <div className={styles.actions}>
                <Button
                    type='Outline-Dark'
                    text='Cancel'
                    disabled={isLoading}
                    className={styles.actions_btn}
                    onClick={() => dispatch(setEditEmailModal(false))}
                />
                <Button
                    type='Primary'
                    text='Confirm'
                    onClick={submit}
                    disabled={!profile}
                    loading={isLoading}
                    className={styles.actions_btn}
                />
            </div>
        </Modal>
    )
}
